import { render, staticRenderFns } from "./InsightFactory.vue?vue&type=template&id=3ef19f33&scoped=true"
import script from "./InsightFactory.vue?vue&type=script&lang=js"
export * from "./InsightFactory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef19f33",
  null
  
)

export default component.exports